import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

blue.ready('testimonial', '.testimonial', testimonial => {
	let container = testimonial.querySelector(".testimonial__swiper");
	let wrapper = testimonial.querySelector(".testimonial__wrapper");
	let slides = [...testimonial.querySelectorAll(".testimonial__slide")];
	let nextEl = testimonial.querySelector('.swiper-button-next');
	let prevEl = testimonial.querySelector('.swiper-button-prev');
	let pagination = testimonial.querySelector('.swiper-pagination, .someOtherNonExistantClass');

	container.classList.add("swiper-container");
	wrapper.classList.add("swiper-wrapper");
	slides.forEach(s => s.classList.add('swiper-slide'))

	if (slides.length > 1) {
		const swiper = new Swiper(container, {
			loop: true,
			navigation: {
				nextEl,
				prevEl
			},
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: pagination,
				type: 'bullets'
			},
		});
	} else {
		nextEl.classList.add('hidden');
		prevEl.classList.add('hidden');
	}
})
